<mat-checkbox #innerCheckbox
              class="wiz-check"
              (click)="onClick()"
              (blur)="wizLoseFocus()"
              [ngClass]="{'checkbox-label-before': wizLabelPosition === 'before'}"
              (focus)="wizGetFocus()"
              [labelPosition]="wizLabelPosition"
              [disabled]="wizDisabled"
              [tabIndex]="wizTabIndex">
              
              <!-- utilisation d'un hgroup pour permettre de d'intervertir la position du label et de l'asterisque en cas de besoin -->
              <div class="wiz-check-content" *ngIf="wizShowLabel"
                  (click)="preventLabel()" (focus)="preventLabel()">
                <span  id="label" #innerLabel wizNotFocusable class="wiz-check-label">{{ translatedLabel }}</span> <!-- label traduit -->
                <span #innerAsterisk wizNotFocusable *ngIf="wizMandatory" class='mandatory-class'>*</span><!-- asterisque -->
              </div>
</mat-checkbox>
